<template>
  <div>
    <el-dialog
      title="生成二次营销人群"
      v-loading="secondLoading"
      width="660px"
      :visible="visible"
      :before-close="handleClose"
    >
      <div class="topTis">
        <img
          src="@/assets/images/提示_黄.png"
          style="
            display: inline-block;
            position: absolute;
            width: 14px;
            height: 14px;
            color: #ffffff;
            left: 15px;
            top: 15px;
          "
        />
        <div class="desc" style="margin-left: 24px">
          <p>提示：</p>
        <p>
          1.针对已发送成功的批次，可以根据组合条件生成新的人群，进行二次营销；
        </p>
        <p>
          2.二次发送人群筛选会因为其他营销行为造成的用户成交而导致筛选结果不够精准。因此建议如需生成二次发送人群，可在营销后3-7天进行，数据相对较为精准；
        </p>
        <p>
          3.
          生成的人群保存至【客户营销-精准营销-客户分群】栏目列表，且人群分类为【二次营销】。
        </p>
        </div>
      </div>
      <el-form
        class="new-input-box second-form"
        ref="secondRef"
        :model="secondForm"
        :rules="secondRules"
        label-width="150px"
      >
        <el-form-item label="人群分类：">
          <el-select
            v-model="classifyId"
            :disabled="true"
            style="width: 460px"
          >
            <el-option
              v-for="(item, index) in crowdClassfyList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人群名称：" prop="name">
          <el-input
            placeholder="请输入"
            show-word-limit
            maxlength="50"
            type="text"
            v-model="secondForm.name"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="人群描述：" prop="description">
          <el-input
            placeholder="请输入"
            show-word-limit
            maxlength="50"
            type="text"
            v-model="secondForm.description"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="二次营销人群选择：" required>
          <span class="form-title">可自由组合二次营销人群，多条件之间是且的关系</span>
        </el-form-item>
        <el-form-item label="触达结果：">
          <el-radio-group v-model="secondForm.touchEffect" :disabled="smsType!=0">
            <el-radio :label="0">不限</el-radio>
            <el-radio :label="1">有触达</el-radio>
            <el-radio :label="2">未触达</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="下单行为：">
          <el-radio-group v-model="secondForm.orderAct">
            <el-radio :label="0">不限</el-radio>
            <el-radio :label="1">有下单</el-radio>
            <el-radio :label="2">未下单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="付款行为：">
          <el-radio-group v-model="secondForm.paymentAct">
            <el-radio :label="0">不限</el-radio>
            <el-radio :label="1">有付款</el-radio>
            <el-radio :label="2">未付款</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="访问行为：">
          <el-radio-group v-model="secondForm.accessAct">
            <el-radio :label="0">不限</el-radio>
            <el-radio :label="1">有访问店铺</el-radio>
            <el-radio :label="2">未访问店铺</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="关注行为：">
          <el-radio-group v-model="secondForm.followAct">
            <el-radio :label="0">不限</el-radio>
            <el-radio :label="1">有关注商品</el-radio>
            <el-radio :label="2">未关注商品</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="加购行为：">
          <el-radio-group v-model="secondForm.secondPayAct">
            <el-radio :label="0">不限</el-radio>
            <el-radio :label="1">有加购商品</el-radio>
            <el-radio :label="2">未加购商品</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button
          type="primary"
          style="margin-right: 12px"
          @click="handleSecondConfirm"
          >确认生成</el-button
        >
        <el-button @click="handleClose"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {smsSendCrowd} from "@/api/marketing/precisionMarketing.js"
export default {
  name: "",
  components: {},
  props: {
    secondMarketingVisible: {
      type: Boolean,
      default: false,
    },
    smsType: {
        type: Number|String,
        default: 0
    },
    recordId: {
      type: Number,
      default: null
    },
    secondSource: {
      type: Number,
      default: 0
    },
    activityTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      visible: this.secondMarketingVisible,
      secondLoading: false,
      crowdClassfyList: [
        {
          label: "二次营销",
          value: "9",//写死，不用传
        },
      ],
      classifyId: "9",//写死，不用传
      secondForm: {
        recordId: this.recordId,
        name: this.activityTitle,
        description: this.activityTitle,
        touchEffect: 0,
        orderAct: 0,
        paymentAct: 0,
        accessAct: 0,
        followAct: 0,
        secondPayAct: 0,
        source: this.secondSource
      },
      secondRules: {
        name: [{ required: true, message: "请输入人群名称", trigger: "blur" }],
        description: [{ required: true, message: "请输入人群描述", trigger: "blur" }],
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    this.secondForm.name +=  " 二次营销 " + this.getNowDate()
    this.secondForm.description += " 二次营销 " + this.getNowDate()
    if(this.secondForm.name.length>50 ||this.secondForm.description.length>50) {
      this.secondForm.name = this.secondForm.name.substring(0,50)
      this.secondForm.description = this.secondForm.description.substring(0,50)
    }
  },
  mounted() {
    this.secondVisible = this.secondMarketingVisible;
  },
  methods: {
    getNowDate() {
      var date = new Date();
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var Hours = date.getHours();
      var Minutes = date.getMinutes();
      var Seconds = date.getSeconds();

      if (Hours >= 0 && Hours <= 9) {
        Hours = "0" + Hours;
      }
      if (Minutes >= 0 && Minutes <= 9) {
        Minutes = "0" + Minutes;
      }
      if (Seconds >= 0 && Seconds <= 9) {
        Seconds = "0" + Seconds;
      }
      var currentdate = date.getFullYear() + "-" + month + "-" + strDate + " " + Hours + seperator2 + Minutes + seperator2 + Seconds;
      return currentdate;
    },
    handleClose(){
        this.$emit("close",false);
    },
    handleSecondConfirm() {
      this.$refs.secondRef.validate(async(valid) => {
        if (valid) {
          this.secondLoading = true
          try {
            const res = await smsSendCrowd(this.secondForm)
            if(res.code==1) {
              this.secondLoading = false
              this.$emit("close",false);
            }
          } catch (error) {
            this.secondLoading = false
          }
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
/* 温馨提示表格 */
.topTis {
  position: relative;

  color: #333333;
  font-size: 14px;
  background: #fffaee;
  opacity: 1;
  padding: 12px;

  .desc {
    line-height: 20px;

    .setting-text {
      margin-bottom: 8px;

      span {
        font-size: 14px;
        color: #7f85e9;
        margin-left: 30px;
        cursor: pointer;

        &:hover {
          color: #fe4d45 !important;
        }
      }
    }

    .count {
      font-weight: bold;
      color: red;
    }
    .count1 {
      color: red;
    }
  }

  p {
    margin: 0px;
    line-height: 20px;
    // width: 700px;
  }
}
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
}
.second-form {
  margin-top: 20px;
  .form-title {
    color: #999;
    font-size: 12px;
  }
}
</style>
